<template>
<div>
    <template v-if="!email_register">
        <div class="modal-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <c-heading-2 class="title mb-2" :style="'font-family:'+$root.$children[0].theme.font_family">Login</c-heading-2>

                        <Login :modal="true" modal_name="login_modal" />
                    
                    </div>

                    <div class="col-md-6">
                        <CreateAnAccount 
                            :modal="true"
                            :modal_register="false"
                        />
                    </div>
                </div>
            </div>
        </div>
    </template>
    <div :style="email_register ? 'display:block;' : 'display:none'">
        <Register 
            modal_name="login_modal"
        />
    </div>
</div>
</template>

<script>
import CreateAnAccount from './CreateAnAccount'
import Login from './Login'
import Register from './register/Register'
import {mapState} from 'vuex'
import { CHeading2 } from '../Styles/Components/styled'

export default {
    name: 'LoginModalApp',
    components: {
        CreateAnAccount,
        Login,
        Register,
        'c-heading-2': CHeading2
    },
    props: {
        modal_name:{required:true, type: String}
    },
    computed: {
        ...mapState("clients", [
            "email_register"
        ])
    }
}
</script>